import { differenceInCalendarDays } from "date-fns";

export const getDaysLeft = (dateString: string): number | null => {
  try {
    const now = new Date();

    const date = new Date(dateString);
    const dtDateOnly = new Date(
      date.valueOf() + date.getTimezoneOffset() * 60 * 1000
    );

    // if (isUTCDateTime(dateString)) {
    //   date = new Date(utcStringToDateTimeTimezone(dateString).date);
    // } else {
    //   date = new Date(dateString);
    // }

    return differenceInCalendarDays(dtDateOnly, now);
  } catch {}
  return null;
};
